<template>
  <div class="info">
    <close-button class="info__close" @click="$emit('close')" />
    <div class="info__container">
      <div class="info__main">
        <transition name="t-fader" @before-leave="beforeLeave">
          <div class="info__thumbnail u-overflow-hidden" :key="picto">
            <img :src="picto" class="u-fit-cover">
          </div>
        </transition>

        </transition name="t-fader" @before-leave="beforeLeave">
          <div class="info__title" :key="title">{{ title }}</div>
        </transition>

        </transition name="t-fader" @before-leave="beforeLeave">
          <p class="info__content" :key="content">{{ content }}</p>
        </transition>
      </div>
      <div class="info__footer">
        <div
          class="info__button info__button--previous"
          @click="$emit('previous')"
        ></div>
        <div
          class="info__button info__button--next"
          @click="$emit('next')"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import CloseButton from './CloseButton.vue'

export default {
  components: {
    CloseButton
  },

  props: {
    title: {
      type: String,
      default: ''
    },
    picto: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    isSelected: {
      type: Boolean,
      default: true
    }
  },

  methods: {
    beforeLeave (el) {
      el.style.width = el.offsetWidth + 'px'
      el.style.height = el.offsetHeight + 'px'
      el.style.top = el.offsetTop + 'px'
      el.style.left = el.offsetLeft + 'px'
      el.style.position = 'absolute'
    }
  }
}
</script>

<style lang="stylus">
@import '~@/styles/settings/variables'

.info
  width 100%
  height 100%
  color: $colors.black

  &::before, &::after
    content ''
    width 100%
    height 100px
    left 0
    position absolute
    pointer-events none
    background-image linear-gradient(to bottom,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.1129) 0.5 * 8.1%,
      rgba(255, 255, 255, 0.2204) 0.5 * 15.5%,
      rgba(255, 255, 255, 0.3225) 0.5 * 22.5%,
      rgba(255, 255, 255, 0.4188) 0.5 * 29%,
      rgba(255, 255, 255, 0.5092) 0.5 * 35.3%,
      rgba(255, 255, 255, 0.5933) 0.5 * 41.2%,
      rgba(255, 255, 255, 0.6709) 0.5 * 47.1%,
      rgba(255, 255, 255, 0.7416) 0.5 * 52.9%,
      rgba(255, 255, 255, 0.805) 0.5 * 58.8%,
      rgba(255, 255, 255, 0.8607) 0.5 * 64.7%,
      rgba(255, 255, 255, 0.9081) 0.5 * 71%,
      rgba(255, 255, 255, 0.9466) 0.5 * 77.5%,
      rgba(255, 255, 255, 0.9754) 0.5 * 84.5%,
      rgba(255, 255, 255, 0.9936) 0.5 * 91.9%,
      rgba(255, 255, 255, 1) 0.5 * 100%,
      rgba(255, 255, 255, 1) 100%
    )

  &::before
    top 0
    transform rotate(180deg)
    z-index 2

  &::after
    bottom 0

  &__container
    background-color $colors.white
    width 100%
    height 100%
    overflow auto
    padding 100px 50px 100px 50px
    box-sizing border-box
    display flex
    flex-direction column
    align-items center

  &__thumbnail
    height 150px
    width 150px
    border-radius 50%
    margin: 0 auto 50px auto

  &__main
    margin-top 50px
    margin-bottom 50px
    position relative

  &__title
    font-size 25px
    font-weight bold

  &__text
    font-size 16px

  &__button
    background-color $colors.white
    width 45px
    height 45px
    border-radius 45px
    box-sizing border-box
    position relative
    cursor pointer
    border 2px solid $colors.black
    flex-grow 0
    flex-shrink 0

    &, &::before, &::after
      transition: .2s

    &::before, &::after
      content ''
      background-color $colors.black
      width 12px
      height 2px
      top 50%
      left 50%
      position absolute

    &:hover
      background-color $colors.black

    &:hover::before, &:hover::after
      background-color $colors.white

    &--previous
      margin-right: 20px

      &::before
        transform translate(-50%, calc(0.5px - 50%)) rotate(-45deg)

      &::after
        transform translate(-50%, calc(-0.5px - 50%)) rotate(45deg)

      &::before, &::after
        transform-origin left center

    &--next
      margin-left: 20px

      &::before
        transform translate(-50%, calc(-0.5px - 50%)) rotate(-45deg)

      &::after
        transform translate(-50%, calc(0.5px - 50%)) rotate(45deg)

      &::before, &::after
        transform-origin right center

  &__close
    top 50px
    left 50%
    position absolute
    transform translateX(-50%)
    z-index: 4

  &__footer
    margin-top auto
    display flex
    z-index 3

  @media screen and (max-width: 850px), screen and (max-height: 600px)
    &__container
      padding 75px 25px 75px 25px

    &__thumbnail
      height 90px
      width 90px
      margin-bottom: 10px

    &__close
      top 25px

     &__title
      font-size 20px
      font-weight bold

    &__text
      font-size 14px

    &__main
      margin-top 10px
      margin-bottom 0

    &__footer
      width calc(100% - 50px)
      top 25px
      left 25px
      position absolute
      display flex
      align-items center
      justify-content space-between
</style>
